import { createContext, useContext, useEffect, useState } from "react";
import api, { clearCsrfToken } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null=loading, false=guest, object=user
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;
    // Only probe session on admin routes to avoid noisy 401s on public pages
    const path = window.location.pathname;
    if (!path.startsWith("/admin")) {
      setUser(false);
      setLoading(false);
      return;
    }
    api.get("/auth/me")
      .then((res) => mounted && setUser(res.data))
      .catch(() => mounted && setUser(false))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  const login = async (email, password) => {
    const { data } = await api.post("/auth/login", { email, password });
    setUser(data);
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch (_) {}
    clearCsrfToken();
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, setUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
